exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.datepicker-container .v-input__slot {\n    margin-bottom: 0px;\n}\n", ""]);
